export interface ILinhVuc {
  id?: number;
  ten?: string | null;
  iconDaiDien?: string | null;
}

export const defaultValue: Readonly<ILinhVuc> = {};
